import { memo } from "react";
import { ChatPaperclipIcon } from "components/shared/svg-action-icons";

const ChatComposerAttachButton = ({
  t,
  fileInputRef,
  onFileChange,
  onFileSelect,
  loading,
  hasPromptPermission,
  isCompact,
  buttonSize,
}) => (
  <>
    <input
      type="file"
      ref={fileInputRef}
      onChange={onFileChange}
      className="hidden"
      disabled={loading || !hasPromptPermission}
    />
    <button
      type="button"
      onClick={onFileSelect}
      disabled={loading || !hasPromptPermission}
      title={t("chat.attach_file")}
      className={`flex-shrink-0 flex items-center justify-center rounded-[9px] bg-transparent text-dark hover:bg-surface-muted transition disabled:opacity-50 disabled:cursor-not-allowed ${buttonSize}`}
    >
      <ChatPaperclipIcon
        className={isCompact ? "w-5 h-5" : "w-[1.375rem] h-[1.375rem]"}
      />
    </button>
  </>
);

export default memo(ChatComposerAttachButton);
